import React, { useState } from 'react';
import '../App.css';
import { useAuth } from '../App';
import { useNavigate } from 'react-router-dom';

const imagenes = [
  'Imagen 1',
  'Imagen 2',
  'Imagen 3',
];

const DetalleProducto = () => {
  const [imgIndex, setImgIndex] = useState(0);
  const { user } = useAuth();
  const navigate = useNavigate();
  const [msg, setMsg] = useState('');

  const handleAdd = e => {
    e.preventDefault();
    if (!user) {
      setMsg('Debes iniciar sesión para comprar.');
      return;
    }
    setMsg('Producto agregado al carrito (simulado)');
  };

  return (
    <section className="detalle-producto-page">
      <div className="detalle-producto-galeria">
        {/* Carrusel/galería de imágenes (placeholders) */}
        <div className="detalle-producto-carrusel">
          <button
            className="detalle-producto-carrusel-btn"
            onClick={() => setImgIndex((imgIndex - 1 + imagenes.length) % imagenes.length)}
            aria-label="Anterior"
          >&#8592;</button>
          <div className="detalle-producto-img-placeholder">
            {imagenes[imgIndex]}
          </div>
          <button
            className="detalle-producto-carrusel-btn"
            onClick={() => setImgIndex((imgIndex + 1) % imagenes.length)}
            aria-label="Siguiente"
          >&#8594;</button>
        </div>
        <div className="detalle-producto-thumbs">
          {imagenes.map((img, i) => (
            <div
              key={i}
              className={`detalle-producto-thumb${i === imgIndex ? ' active' : ''}`}
              onClick={() => setImgIndex(i)}
            >
              {img}
            </div>
          ))}
        </div>
        <div className="detalle-producto-galeria-aviso">
          <em>Soporte para múltiples imágenes por producto (solo visual, sin backend aún).</em>
        </div>
      </div>
      <div className="detalle-producto-info">
        <h2>Nombre del Producto</h2>
        <div className="detalle-producto-precio">$0.00</div>
        <p className="detalle-producto-desc">Descripción breve y atractiva del producto. Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
        <div className="detalle-producto-acciones">
          <input type="number" min="1" max="99" defaultValue="1" className="detalle-producto-cantidad" />
          <button className="detalle-producto-add-btn" onClick={handleAdd}>
            Agregar al carrito
          </button>
        </div>
        {msg && (
          <div className="detalle-producto-msg">
            {msg} {!user && (
              <button className="detalle-producto-login-btn" onClick={() => navigate('/login')}>Iniciar sesión</button>
            )}
          </div>
        )}
      </div>
    </section>
  );
};

export default DetalleProducto; 